import styled from "styled-components";

export const StyledSideNavbar = styled.section`
  position: sticky;
  padding: 40px 12px;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  
`;

export const StyledSideNavbarEle = styled.div`
  a {
    color: inherit;
    text-decoration: none;
  }

  padding: 4px 0;
  font-size: 20px;
`;
